import { render, staticRenderFns } from "./NotificationTable.vue?vue&type=template&id=1c17404c&"
import script from "./NotificationTable.vue?vue&type=script&lang=ts&"
export * from "./NotificationTable.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationTable.vue?vue&type=style&index=0&id=1c17404c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports